module.exports = __webpack_public_path__ + "img/inbox-01.f646464b.svg";